import { makeStyles, TextField } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
	input: {
		marginBottom: theme.spacing(2),
		width: '32%'
		// marginRight: theme.spacing(2)
	}
}))

export const HiddenInput = () => {
	const classes = useStyles()

	return <TextField variant="filled" className={classes.input} disabled style={{ opacity: 0 }} />
}
